exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n.hasError[data-v-52509a8c] {\n  border: solid 0.1rem red;\n}\n.form-input[data-v-52509a8c].bim-input, .form-input[data-v-52509a8c].bim-input input {\n  width: 100%;\n  height: 100%;\n}\n.form-input[data-v-52509a8c].bim-input input {\n  border: none;\n}", ""]);

// exports
